'use strict';
module.exports = require('../../full/array/from');



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/features/array/from.js
// module id = 347
// module chunks = 0